import { getPrizeList } from '@this/services/my';
const state = {
  prizeList: [],
  prizeMetal: {},
};

const mutations = {
  setPrizeList(state, list) {
    state.prizeList = list;
  },
  setPrizeMetal(state, obj) {
    state.prizeMetal = obj;
  },
};

const actions = {
  // 事件
  getPrizeList({ state, commit }, page) {
    const {
      prizeList,
      prizeMetal: { current_page = 0 },
    } = state;
    const thisPage = page || current_page + 1;
    return getPrizeList({
      page: thisPage,
      size: 8,
    }).then((res) => {
      let newPrizeList = [];
      if (thisPage === 1) {
        newPrizeList = res.data.list;
      } else {
        newPrizeList = [...prizeList, ...res.data.list];
      }
      commit('setPrizeList', newPrizeList);
      commit('setPrizeMetal', res.data.total);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
